import { normalizeOrderForPdf } from './normalizeOrderForPdf';
import { normalizeSkuListForPdf } from './normalizeSkuListForPdf';

/**
 * @param {Record<string, unknown>} order
 * @param {{ old?: boolean; extraInfoLookup?: Array<{ owner: string; extraInfo: object }> }} [options]
 */
export function normalizeDeliveryNoteForPdf(order, options = {}) {
    const { extraInfoLookup, ...rest } = options;
    const base = normalizeOrderForPdf(order, { ...rest, variant: 'delivery' });
    const rows = order?.deliveryNote || [];

    return {
        title: 'Delivery note',
        orderNumber: base.orderNumber,
        invoiceNumber: base.invoiceNumber,
        status: base.status,
        orderDate: base.orderDate,
        note: base.note,
        billing: base.billing,
        delivery: base.delivery,
        lines: normalizeSkuListForPdf(rows, extraInfoLookup, order?.cart),
    };
}
